var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlatformApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5148_5086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.792 18.7033C21.429 19.5418 20.9994 20.3136 20.5017 21.0232C19.8232 21.9906 19.2676 22.6602 18.8395 23.032C18.1758 23.6424 17.4647 23.955 16.7033 23.9728C16.1566 23.9728 15.4974 23.8172 14.73 23.5017C13.9601 23.1876 13.2525 23.032 12.6056 23.032C11.9271 23.032 11.1994 23.1876 10.4211 23.5017C9.64154 23.8172 9.01356 23.9816 8.53343 23.9979C7.80323 24.029 7.0754 23.7076 6.3489 23.032C5.88522 22.6276 5.30523 21.9343 4.61044 20.9521C3.86498 19.9032 3.25211 18.687 2.77198 17.3004C2.25777 15.8026 2 14.3523 2 12.9482C2 11.3398 2.34754 9.95259 3.04367 8.7901C3.59077 7.85636 4.3186 7.11979 5.22953 6.57906C6.14047 6.03834 7.12473 5.76279 8.1847 5.74516C8.76468 5.74516 9.52525 5.92456 10.4704 6.27715C11.4129 6.63091 12.0181 6.81031 12.2834 6.81031C12.4818 6.81031 13.154 6.60054 14.2937 6.18233C15.3714 5.79449 16.281 5.63391 17.0262 5.69716C19.0454 5.86012 20.5624 6.6561 21.5713 8.09013C19.7654 9.18432 18.8721 10.7169 18.8899 12.6829C18.9062 14.2142 19.4617 15.4886 20.5535 16.5004C21.0483 16.97 21.6009 17.333 22.2157 17.5907C22.0824 17.9774 21.9416 18.3477 21.792 18.7033ZM17.161 0.480137C17.161 1.68041 16.7225 2.8011 15.8485 3.8384C14.7937 5.07155 13.5179 5.78412 12.1344 5.67168C12.1167 5.52769 12.1065 5.37614 12.1065 5.21688C12.1065 4.06462 12.6081 2.83147 13.4989 1.82321C13.9436 1.3127 14.5092 0.888228 15.1952 0.549615C15.8796 0.216055 16.527 0.031589 17.1358 0C17.1536 0.160458 17.161 0.320941 17.161 0.480137Z",
    fill: "#D4D8E3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5148_5086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2157,
    height: 24,
    fill: "white",
    transform: "translate(2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformApple);
export default __webpack_public_path__ + "static/media/platform-apple.5c846f8b0da4f61392f5b3d6f61bdfe3.svg";
export { ForwardRef as ReactComponent };